module.exports = __webpack_public_path__ + "img/qrcode.62658140.jpg";